import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { coreBasicApiUrlPrefix } from 'library-@/config/constants';
import type { ApiGetClaimCompareExportRequest, GetClaimCompareExport } from '../get-claim-compare-export-api';

@injectable()
export class CoreBasicApiServiceImpl extends PsHttpService 
    implements GetClaimCompareExport {
    get options() {
        return {
            baseURL: coreBasicApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getClaimCompareExport(data: ApiGetClaimCompareExportRequest): Promise<string> {
        const res = await this.post<PatSnapSuccessResponseData<string>>({
            url: '/analytics/export/excel',
            data,
            transformCode: true,
        });
        return res.data;
    }

    // async getClaimCompareExport(data: ApiGetClaimCompareExportRequest): Promise<any> {
    //     const res = await this.post<any>({
    //         url: '/analytics/export/excel',
    //         data,
    //         responseType: 'blob',
    //         transformResponse: (data, headers) => {
    //             const filename = decodeURIComponent(headers?.['content-disposition']?.split('filename=')[1]?.split(';')[0] || '');
    //             return {
    //                 blob: data,
    //                 filename: filename || '',
    //             };
    //         },
    //     });
    //     return res;
    // }
}
